enum EProductTaxCategory {
  SOFTWARE = 'software',
  SERVICES = 'services',
  SAAS = 'saas',
  EBOOKS = 'ebooks',
}

export default EProductTaxCategory;
